import CONSTANTS from '@/constants'
import { UserProfile, Provider } from '../../types'

interface AuthState {
  userProfile: UserProfile
  isAuthenticated: boolean
  isAdmin?: boolean
  isContentCreator: boolean
  isAuthLoading: boolean
  isTwoFactorRequired: boolean
  redirectUrl?: string
  sampleAvatars?: Array<object>
  currentAvatar: string
  subscriptionStatus?: string
  profilePreferences?: object
  authProviders: Array<Provider>
  isEnrolledInSecurityAwareness: boolean
}

const state: AuthState = {
  userProfile: {
    account_id: '',
    mfa_required: null,
    avatar: '',
    preferred_phone_number: '',
    mfa_method: '',
  },
  isAuthenticated: false,
  isAdmin: false,
  isContentCreator: false,
  isAuthLoading: false,
  isTwoFactorRequired: false,
  redirectUrl: '',
  sampleAvatars: [],
  currentAvatar: '/assets/icons/avatars/avatar1.png',
  subscriptionStatus: '',
  profilePreferences: {},
  authProviders: CONSTANTS.AUTH_PROVIDERS,
  isEnrolledInSecurityAwareness: false,
}

export { AuthState, state }
